import React from "react";
import data from "../../../template/copy.json";
import logo from "../../assets/logo_white.png";

const Landing = () => {
  return (
    <div className="landing">
      <span className="title">
        <img src={logo} />
        <h1>{data.landing.title}</h1>
      </span>
      <div
        dangerouslySetInnerHTML={{
          __html: data.landing.intro.split("\n").join("<br />"),
        }}
      ></div>
    </div>
  );
};

export default Landing;
